import { render, staticRenderFns } from "./AnswerTypeRanking.vue?vue&type=template&id=435099e5&scoped=true"
import script from "./AnswerTypeRanking.vue?vue&type=script&lang=js"
export * from "./AnswerTypeRanking.vue?vue&type=script&lang=js"
import style0 from "./AnswerTypeRanking.vue?vue&type=style&index=0&id=435099e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435099e5",
  null
  
)

export default component.exports